import { useGlobalContext } from '../context'

function VotingScreen() {
    const { players, index, deathStatement, voteForKill, vote, nextVoter, finishVoting} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border text-center'>
            <p className='mt-4'>{deathStatement}Now vote to eliminate a player.</p>
            <p>Player to vote: {currentPlayer.name}</p>
            <button className={index === players.length - 1 ? 'hidden' : 'btn btn-dark pl-5 pr-5'} onClick={() => nextVoter(index)}>Next voter</button>
            <button className={index !== players.length -1 ? 'hidden' : 'btn btn-dark pl-5 pr-5'} onClick={() => finishVoting()}>Finish Voting</button>
            <div className='vote-buttons'>
                {players.map((player, index) => {
                    return (<button key={index} disabled={vote ? 'disabled' : ''} className='btn vote-btn text-center btn-dark p-4 m-1' onClick={() => voteForKill(index)}>{`${player.name}(${player.voteCount})`}</button> ) 
                })}
            </div>
        </div>
    )
}

export default VotingScreen;